export default {
  'caas.self.account': 'Account',
  'caas.self.name': 'User Name',
  'caas.self.phone': 'Phone',
  'caas.self.isauthen': 'Is Authenticated',
  'caas.self.update.basic': 'Update Basic',
  'caas.self.update.password': 'Update Password',
  'caas.self.real.authentication': 'Authentication',
  'caas.self.bind.wechat': 'Bind WeChat'
}
